import { UserFeedbackContent } from "../steps/UserFeedback/components/UserFeedbackContent";

import { readSurveyContent } from "./content";
import { type StepProps } from "./taskRenderers";
import { useCompleteTaskV2 } from "./useCompleteTaskV2";

export const SurveyStep = ({ task, onComplete }: StepProps) => {
  const { completeTask, isPending } = useCompleteTaskV2();
  const { questions } = readSurveyContent(task.content);

  const ratingQuestion = questions?.find(({ type }) => type === "RATING");
  const freeTextQuestion = questions?.find(({ type }) => type === "FREE_TEXT");

  const handleSubmit = (payload: {
    rating: number | null;
    suggestions: string;
  }) => {
    const capturedData: { score?: number; comment?: string } = {};

    if (ratingQuestion && payload.rating !== null) {
      capturedData.score = payload.rating;
    }

    if (freeTextQuestion) {
      capturedData.comment = payload.suggestions;
    }

    completeTask(
      { taskId: task.id, data: { capturedData } },
      { onSuccess: () => onComplete() },
    );
  };

  const handleSkip = () => {
    completeTask(
      {
        taskId: task.id,
        data: { capturedData: {} },
      },
      { onSuccess: () => onComplete() },
    );
  };

  return (
    <UserFeedbackContent
      improvementLabel={freeTextQuestion?.label}
      improvementPlaceholder={freeTextQuestion?.placeholderText}
      isSubmitting={isPending}
      onSkip={handleSkip}
      onSubmit={handleSubmit}
      question={task.taskDescription}
      scaleMaxLabel={ratingQuestion?.maxLabel}
      scaleMinLabel={ratingQuestion?.minLabel}
      scaleQuestion={ratingQuestion?.label}
      title={task.name}
    />
  );
};
